module.exports = __webpack_public_path__ + "img/about_h3-image.08bfea75.jpg";